import React, { useContext, useRef, useState } from "react";

import makeStyles from '@mui/styles/makeStyles';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import _ from "lodash";
import messages from "../services/messages";
import config from "../config";
import ShareDialog from "./ShareDialog";
import LanguageContext from "../LanguageContext";
import firebase from "../firebase";
import UserService from "../services/UserService";
import Chip from "@mui/material/Chip";
import ButtonBase from "@mui/material/ButtonBase";
import { useHistory } from "react-router-dom";
import VideosService from "../services/VideosService";
import {
  ThumbUp,
  ThumbUpAlt,
  ThumbUpAltOutlined,
  ThumbUpOutlined,
  Visibility,
  VisibilityOutlined,
} from "@mui/icons-material";
import { WhatsappShareButton } from "react-share";
import { Divider, Icon, SvgIcon } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "8px",
    // marginRight:theme.spacing(-2)
  },
  contentCardContainer: {
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
    marginBottom: theme.spacing(-0.8),
  },
  socialProofContainer: {
    marginBottom: theme.spacing(-1.2),
    marginTop: theme.spacing(-0.8),
  },
  ytDialog: {
    backgroundColor: "black",
  },
  playButtonBase: {
    top: theme.spacing(-10.6),
    left: "30%",
    marginBottom: theme.spacing(-8.5),
  },
  playButton: {
    width: "48px",
    height: "48px",
    opacity: "0.9",
  },
  contentVideoTitle: {
    fontWeight: 600,
    // fontSize:"14px",
    marginTop: theme.spacing(1),
  },

  authorContainer: {
    marginTop: theme.spacing(1),
  },
  authorName: {
    // marginLeft: theme.spacing(0.5),
    fontSize: "12px",
    color: "#666666",
  },
  avatar: { width: theme.spacing(4), height: theme.spacing(4) },
  contentVideoThumbnailContainer: {
    marginBottom: theme.spacing(-2),
    background: "#000000",
    // opacity: "0.3",
    borderRadius: "4px",
  },
  contentVideoThumbnail: {
    // background: "#000000",
    opacity: "0.7",
    objectFit: "cover",
  },
  contentVideoThumbnailCardMedia: {
    borderRadius: "4px",
  },
  stageLabel: {
    background: "#FDF4E2",
    color: "#666666",
    fontSize: theme.spacing(1.5),
    marginTop: theme.spacing(0.5),
  },
  stageIcon: {
    height: theme.spacing(1.8),
    width: theme.spacing(1.8),
  },
  viewsIconContainer: {
    marginTop: theme.spacing(-2.5),

    marginLeft: theme.spacing(-7.0),
  },

  viewsIcon: {
    height: theme.spacing(2.5),
    // marginTop: theme.spacing(-2.5),
    color: "#FFFFFF",

    // marginBottom: theme.spacing(2),
  },
  viewsCount: {
    color: "#FFFFFF",
    // marginTop: theme.spacing(-2),
    // paddingBottom: theme.spacing(0.2),
  },
  newTagContainer: {
    marginTop: theme.spacing(-2.5),
    marginLeft: theme.spacing(-5.4),
    paddingLeft: theme.spacing(0.3),
    paddingRight: theme.spacing(0.3),
    paddingBottom: theme.spacing(0),
    paddingTop: theme.spacing(0.2),
    borderRadius: theme.spacing(0.3),
    color: "#FFFFFF",
    height: theme.spacing(2.5),
    background: "#ef5350",
  },
  newTag: {},
  likeButton: {
    marginTop: theme.spacing(0.2),
    marginBottom: theme.spacing(-0.7),
    // height: theme.spacing(1),
  },
  likeIcon: {
    height: theme.spacing(2.5),
  },
  unlikeIcon: {
    height: theme.spacing(2.5),
  },
  likesCount: {
    marginLeft: theme.spacing(0.4),
    color: "#333333",
    paddingTop: theme.spacing(0.5),
  },
  shareIconContainer: {
    // marginTop: theme.spacing(1),
  },
  shareIcon: {
    marginTop: theme.spacing(1.7),
    height: theme.spacing(2.5),
  },
  sharesCount: {
    marginLeft: theme.spacing(-0.3),
    marginTop: theme.spacing(1.7),
  },
  divider: {
    marginTop: theme.spacing(0.5),
  },
}));

function ContentVideoCard(props) {
  const classes = useStyles();
  let history = useHistory();

  const language = useContext(LanguageContext);
  let { mobile } = UserService.getUserInfo();

  let [contentVideo, setContentVideo] = useState(props.contentVideo);
  let [contentVideos, setContentVideos] = useState(props.contentVideos);

  const getShareText = () => {
    let shareText = `${props.contentVideo.cropName} ${messages["cropPage.contentVideo.shareText"][language]} ${window.location.href}/content/${props.contentVideo.youtube_id} ${messages["cropPage.contentVideo.agrostarAppShareText"][language]}`;
    if (props.contentVideo?.cropData?.name_en === "Weather") {
      shareText = `${props.contentVideo.cropName} ${messages["cropPage.contentVideo.shareText"][language]} ${window.location.href}/content/${props.contentVideo.youtube_id} ${messages["cropPage.contentVideo.agrostarAppShareText"][language]}`;
    }
    return shareText;
  };

  const likeAVideo = (event) => {
    event.stopPropagation();

    VideosService.logVideoActivity(contentVideo.youtube_id, "liked", props.mobile)
      .then(() => {})
      .catch(() => {});

    let newLikes = contentVideo.likes ? contentVideo.likes + 1 : 1;
    firebase.analytics().logEvent("content_video_liked", {
      crop_name: contentVideo.cropData.name_en,
      author_name: contentVideo.authorData.name_en,
      title: contentVideo.title,
      weeks_after_sowing: contentVideo.weeks_after_sowing,
      stage: contentVideo.stageData.name_en,
      crop_age: contentVideo.crop_age,
      state: contentVideo.stateData.name_en,
      position: props.position,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      crop_segment: contentVideo.crop_segment,
      youtube_id: contentVideo.youtube_id,
      user_source: props.userSource,
      page_name: window.location.pathname,
      skus: props.contentVideo.skus,
    });
    const newContentVideos = contentVideos?.map((video) => {
      if (video.youtube_id === contentVideo.youtube_id) {
        return { ...video, likes: newLikes, likedByMe: true };
      }
      return video;
    });
    setContentVideos(newContentVideos);
    setContentVideo({ ...contentVideo, likes: newLikes, likedByMe: true });
  };

  const unlikeAVideo = (event) => {
    event.stopPropagation();

    VideosService.logVideoActivity(
      contentVideo.youtube_id,
      "unliked",
      props.mobile
    )
      .then(() => {})
      .catch(() => {});

    let newLikes = contentVideo.likes ? contentVideo.likes - 1 : 0;

    firebase.analytics().logEvent("content_video_unliked", {
      crop_name: contentVideo.cropData.name_en,
      author_name: contentVideo.authorData.name_en,
      title: contentVideo.title,
      weeks_after_sowing: contentVideo.weeks_after_sowing,
      stage: contentVideo.stageData.name_en,
      crop_age: contentVideo.crop_age,
      state: contentVideo.stateData.name_en,
      position: props.position,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      crop_segment: contentVideo.crop_segment,
      youtube_id: contentVideo.youtube_id,
      user_source: props.userSource,
      page_name: window.location.pathname,
      skus: props.contentVideo.skus,
    });
    const newContentVideos = contentVideos?.map((video) => {
      if (video.youtube_id === contentVideo.youtube_id) {
        return { ...video, likes: newLikes, likedByMe: false };
      }
      return video;
    });
    setContentVideos(newContentVideos);
    setContentVideo({ ...contentVideo, likes: newLikes, likedByMe: false });
  };

  const share = async (event) => {
    event.stopPropagation();

    const { mobile } = UserService.getUserInfo();

    firebase.analytics().logEvent("content_video_shared_on_whatsapp", {
      mobile,
      crop_name: props.contentVideo.cropData.name_en,
      author_name: props.contentVideo.authorData.name_en,
      title: props.contentVideo.title,
      weeks_after_sowing: props.contentVideo.weeks_after_sowing,
      stage: props.contentVideo.stageData.name_en,
      state: props.contentVideo.stateData.name_en,
      position: props.position,
      user_type: props.userType,
      crop_segment: props.contentVideo.crop_segment,
      farmer_crops: JSON.stringify(props.farmerCrops),
      user_source: props?.userSource,
      page_name: window.location.pathname,
      skus: props.contentVideo.skus,
    });

    let newSharesCount = contentVideo.shares_count
      ? contentVideo.shares_count + 1
      : 1;
    const newContentVideos = contentVideos?.map((video) => {
      if (video.youtube_id === contentVideo.youtube_id) {
        return { ...video, shares_count: newSharesCount };
      }
      return video;
    });
    setContentVideos(newContentVideos);

    setContentVideo({ ...contentVideo, shares_count: newSharesCount });

    VideosService.logVideoActivity(props.contentVideo.youtube_id, "shared")
      .then(() => {})
      .catch(() => {});
  };

  const handleYtModal = () => {
    firebase.analytics().logEvent("content_video_dialog_opened", {
      mobile,
      crop_name: contentVideo.cropData.name_en,
      author_name: contentVideo.authorData.name_en,
      title: contentVideo.title,
      weeks_after_sowing: contentVideo.weeks_after_sowing,
      stage: contentVideo.stageData.name_en,
      state: contentVideo.stateData.name_en,
      position: props.position,
      user_type: props.userType,
      crop_segment: contentVideo.crop_segment,
      farmer_crops: JSON.stringify(props.farmerCrops),
      user_source: props?.userSource,
      youtube_id: contentVideo.youtube_id,
      skus: contentVideo.skus,
    });
    history.push({
      pathname: `${contentVideo.cropData.name_en}/content/${contentVideo.youtube_id}`,
      state: {
        contentVideo: contentVideo,
        mobile: mobile,
        farmerCrops: props.farmerCrops,
        position: props.position,
        userSource: props.userSource,
        userType: props.userType,
        videosPlaylist: props.videosPlaylist,
        contentVideos: contentVideos,
        userLanguage: language,
        skus: contentVideo.skus,
      },
    });
  };

  return <>
    {contentVideo && !_.isEmpty(contentVideo) && (
      <>
        <Card
          className={classes.root}
          variant={"outlined"}
          onClick={handleYtModal}
        >
          <CardContent className={classes.contentCardContainer}>
            <Grid
              container
              direction="row"
              justifyContent={"flex-start"}
              alignItems={"flex-start"}
              spacing={1}
            >
              <Grid item xs={5}>
                <div className={classes.contentVideoThumbnailContainer}>
                  <CardMedia
                    component="img"
                    height="105"
                    width="140"
                    image={contentVideo.youtube_thumbnail}
                    alt={contentVideo.cropName}
                    title={contentVideo.title}
                    classes={{
                      root: classes.contentVideoThumbnailCardMedia,
                      img: classes.contentVideoThumbnail,
                    }}
                  />
                </div>

                <ButtonBase
                  centerRipple={true}
                  focusRipple={true}
                  aria-label="play"
                  className={classes.playButtonBase}
                  size="medium"
                >
                  <img
                    src="../../icons/playcircle.svg"
                    alt="play"
                    className={classes.playButton}
                  />
                </ButtonBase>
                {contentVideo.views_count && contentVideo.views_count > 24 ? (
                  <IconButton
                    aria-label="views"
                    edge={"start"}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className={classes.viewsIconContainer}
                    size="large">
                    <Visibility className={classes.viewsIcon} />
                    <Typography
                      variant={"caption"}
                      className={classes.viewsCount}
                    >
                      {contentVideo.views_count}
                    </Typography>
                  </IconButton>
                ) : (
                  <IconButton
                    edge={"start"}
                    className={classes.newTagContainer}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    size="large">
                    <Typography
                      variant={"caption"}
                      className={classes.newTag}
                    >
                      {messages[`cropPage.contentVideo.newTag`][language]}
                    </Typography>
                  </IconButton>
                )}
              </Grid>
              <Grid item xs={7}>
                <Grid
                  container
                  direction="row"
                  justifyContent={"flex-start"}
                  alignItems={"flex-start"}
                >
                  <Grid item xs={12}>
                    <Chip
                      icon={
                        <img
                          src={"../../icons/crops_stage.svg"}
                          alt={""}
                          className={classes.stageIcon}
                        />
                      }
                      size={"small"}
                      label={
                        <Typography className={classes.stageLabel}>
                          {props.contentVideo.stageName.length > 26 ? (
                            <>
                              {props.contentVideo.stageName.substr(0, 26)}
                              ...
                            </>
                          ) : (
                            <>{props.contentVideo.stageName}</>
                          )}
                        </Typography>
                      }
                      className={classes.stageLabel}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent={"flex-start"}
                  alignItems={"flex-start"}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant={"body2"}
                      className={classes.contentVideoTitle}
                    >
                      {contentVideo.title}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  className={classes.authorContainer}
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <Grid item xs={3}>
                    <Avatar
                      aria-label="author"
                      src={`${
                        config.gcpBucketBase
                      }content${encodeURIComponent(
                        contentVideo.authorImage
                      )}?alt=media`}
                      className={classes.avatar}
                    >
                      {contentVideo && contentVideo.authorName && (
                        <>{contentVideo.authorName.charAt(0)}</>
                      )}
                    </Avatar>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography className={classes.authorName}>
                      {messages["dashboard.live.byAuthor"][language]}
                      {contentVideo.authorName}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Divider className={classes.divider} />
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              className={classes.socialProofContainer}
            >
              <Grid item xs={2} />
              <Grid item xs={3}>
                  {contentVideo.likedByMe ? (
                  <IconButton
                    aria-label="unlike"
                    onClick={unlikeAVideo}
                    className={classes.likeButton}
                    size="large">
                    <img
                      src={`../../icons/liked-orange.svg`}
                      className={classes.unlikeIcon}
                    />
                    <Typography
                      variant={"caption"}
                      className={classes.likesCount}
                    >
                        {contentVideo.likes || ``}
                    </Typography>
                  </IconButton>
                ) : (
                  <IconButton
                    aria-label="like"
                    onClick={likeAVideo}
                    className={classes.likeButton}
                    size="large">
                    <img
                      src={`../../icons/like.svg`}
                      className={classes.likeIcon}
                    />
                    <Typography
                      variant={"caption"}
                      className={classes.likesCount}
                    >
                        {contentVideo.likes || ``}
                    </Typography>
                  </IconButton>
                )}
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={3}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="flex-start"
                >
                  <Grid item xs={4}>
                    <WhatsappShareButton
                      url={`https://agrostar.onelink.me/9ngX/gold${props.userState?.code?.toLowerCase()}`}
                      title={`${getShareText()}`}
                      onClick={share}
                      className={classes.shareIconContainer}
                    >
                      <img
                        className={classes.shareIcon}
                        src="../../icons/whatsapp.svg"
                        alt="whatsapp-share"
                      />
                    </WhatsappShareButton>
                  </Grid>
                  <Grid item xs={5} className={classes.sharesCount}>
                    <Typography variant={"caption"}>
                      {contentVideo.shares_count}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} />
            </Grid>
          </CardContent>
        </Card>
      </>
    )}
  </>;
}

export default ContentVideoCard;
